import { useEffect } from "react";

export default function useHTMLTitle($title:string){
    useEffect(()=>{
        document.title = $title + " - PSAP Link";
    },[$title]);
}